import TicketNav from "./TicketNav";
import cloudsync from '../cloudsync.gif';

const TicketHeader = (props) => {
    const {
        mergeRequired,
        handleSelectTicketTab,
        selectedTab,
        closeTicketWindow,
        editTicket,
        saving,
        poleIssue
    } = props;

    return (
        <div className={`modal-header flex-column flex-sm-row justify-content-end modalHeader`}>
            <h5
                className={`modal-title mr-auto modalTitle`}
                id="createTicketModalLabel">
                {editTicket ? 'Edit Ticket' : 'Create Ticket'}
            </h5>

        {!mergeRequired &&
            <nav className={`modalNav}`}>
                <div className="nav nav-tabs d-flex flex-row modalNavTabs" id="nav-tab" role="tablist">
                    <TicketNav 
                        tabName={'home'}
                        selected={selectedTab === 'home'}
                        tabDisplayName={'Pole'}
                        poleIssue={false}
                        handleSelectTicketTab={handleSelectTicketTab}
                    />
                    <TicketNav 
                        tabName={'info'}
                        selected={selectedTab === 'info'}
                        tabDisplayName={'Info'}
                        poleIssue={poleIssue}
                        handleSelectTicketTab={handleSelectTicketTab}
                    />
                    <TicketNav 
                        tabName={'tasks'}
                        selected={selectedTab === 'tasks'}
                        tabDisplayName={'Tasks'}
                        poleIssue={poleIssue}
                        handleSelectTicketTab={handleSelectTicketTab}
                    />
                </div>                    
            </nav>
        }

            <img 
                src={cloudsync} style={{height:'40px'}}
                className={saving?'':'hidden'}
                alt=""
                />
            <button
                type="button"
                className={`close modalHeaderClose`}
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => closeTicketWindow(false)}
            >
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    );
}

export default TicketHeader